import request from '@/utils/request'
import URL from '@/api/urlTranslator'

export function getReasonForJudgmentList(params) {
  return request({
    url: URL.mdm.basicData.reasonForJudgment,
    method: 'get',
    params
  })
}

export function saveReasonForJudgment(data) {
  return request({
    url: URL.mdm.basicData.reasonForJudgment,
    method: data.uuid ? 'put' : 'post',
    data
  })
}

export function delReasonForJudgment(uuid) {
  return request({
    url: URL.mdm.basicData.reasonForJudgment + '?uuid=' + encodeURIComponent(uuid),
    method: 'delete'
  })
}
